if (!customElements.get('section-ugc')) {
	customElements.define(
		'section-ugc',
		class SectionUGC extends HTMLElement {
			constructor() {
				super()

				this.mainSwiper = this.querySelector('[data-swiper]')
				this.subSwiper = this.querySelector('[data-sub-swiper]')
				this.modal = this.querySelector('[data-modal]')
				this.modalCloseBtn = this.querySelector('[data-modal-close]')

				this.videoTriggers = this.querySelectorAll('[data-video-trigger]')
				this.videos = this.querySelectorAll('[data-video]')

				this.muteAllVideos()

				this.setupCarousel()
				this.openVideosModal()
				this.muteVideoEvents()
			}

			setupCarousel() {
				const swiperPrev = this.querySelector('[data-swiper-prev]')
				const swiperNext = this.querySelector('[data-swiper-next]')

				this.mainCarousel = new Swiper(this.mainSwiper, {
					loop: false,
					allowTouchMove: true,
					slidesPerView: 'auto',
					spaceBetween: 32,
					navigation: {
						nextEl: swiperNext,
						prevEl: swiperPrev,
					},
				})

				this.prevNavigationBtn = this.querySelector('[data-sub-swiper-prev]')
				this.nextNavigationBtn = this.querySelector('[data-sub-swiper-next]')

				this.subCarousel = new Swiper(this.subSwiper, {
					slidesPerView: 'auto',
					speed: 300,
					loop: true,
					effect: 'fade',
					navigation: {
						nextEl: this.prevNavigationBtn,
						prevEl: this.nextNavigationBtn,
					},
				})

				this.subCarousel.on('slideChange', () => {
					debounce(() => {
						this.videos.forEach((videoContainer, index0) => {
							const slide = videoContainer.parentElement
							const video = videoContainer.querySelector('video')
							const videoMuted = videoContainer.querySelector('[data-modal-video-mute]')

							if (this.modal.classList.contains('is-active')) {
								if (slide.classList.contains('swiper-slide-active')) {
									this.muteAllVideos()

									video.play()
									video.muted = false
									videoMuted.classList.remove('is-muted')
								}
							}
						})
					}, 200)()
				})
			}

			openVideosModal() {
				this.videoTriggers.forEach((videoTrigger) => {
					videoTrigger.addEventListener('click', () => {
						const videoId = videoTrigger.dataset.videoTrigger

						this.videos.forEach((videoContainer, index0) => {
							const _videoId = videoContainer.dataset.video
							const video = videoContainer.querySelector('video')
							const videoMuted = videoContainer.querySelector('[data-modal-video-mute]')

							if (_videoId == videoId) {
								this.subCarousel.slideTo(index0)
								video.play()
								videoMuted.classList.remove('is-muted')
							} else {
								videoMuted.classList.add('is-muted')
							}
						})

						this.modal.classList.add('is-active')
					})
				})

				this.modalCloseBtn.addEventListener('click', this.onCloseModal.bind(this))
			}

			onCloseModal() {
				this.modal.classList.remove('is-active')
				this.muteAllVideos()
			}

			muteAllVideos() {
				this.videos.forEach((videoContainer) => {
					const video = videoContainer.querySelector('video')
					const videoMuted = videoContainer.querySelector('[data-modal-video-mute]')

					video.muted = true
					video.pause()
					videoMuted.classList.add('is-muted')
				})
			}

			muteVideoEvents() {
				this.videoMutedBtns = this.querySelectorAll('[data-modal-video-mute]')

				this.videoMutedBtns.forEach((videoMutedBtn) => {
					videoMutedBtn.addEventListener('click', () => {
						const video = videoMutedBtn.parentElement.querySelector('video')

						if (videoMutedBtn.classList.contains('is-muted')) {
							videoMutedBtn.classList.remove('is-muted')
							video.muted = false
						} else {
							videoMutedBtn.classList.add('is-muted')
							video.muted = true
						}
					})
				})

				this.videos.forEach((videoContainer) => {
					const video = videoContainer.querySelector('video')

					video.addEventListener('click', () => {
						video.paused || video.ended ? video.play() : video.pause()
					})
				})
			}
		}
	)
}

